import React, { useContext, useEffect } from 'react'
import { IframeLayout } from '../../../components/Layouts'
import { ErrorBoundary } from '@sentry/react'
import { ErrorMsg } from '../../../components/AppMessages'
import { IframePageContent } from '../../../components/PageContent'
import { SeoFilters } from '../../../components/Filters/SeoFilters'
import { DashboardBannerContext } from "../../../context";

const SearchInterestReport = () => {
  const { setBannerText, setShowBanner } = useContext(DashboardBannerContext);

  useEffect(() => {
    setBannerText(
      <>
        Access is provided by Google. Please, follow the steps on this{" "}
        <a href="http://accounts.google.com/signupwithoutgmail" target="_blank" rel="noopener noreferrer">
          link
        </a>{" "}
        to link your Nissan ID to Google and allow up to 5 business days for new user activation once you inform us your Nissan ID has
        been associated to Google. For assistance, reach out to nissan.support@artefact.com.
      </>
    );
    setShowBanner(true);
    // DashboardBannerContext lives in App.tsx, above the router - it never unmounts on navigation,
    // so showBanner/bannerText persist across routes unless explicitly reset here (see
    // CcsMonetizationFilters.tsx's own comment on this exact leak).
    return () => {
      setShowBanner(false);
      setBannerText("");
    };
  }, []);
  return (
    <>

      <IframeLayout hasFilter={true}>
        <ErrorBoundary fallback={<ErrorMsg />}>
          <IframePageContent
            frameId="search_interest_report"
            filter={<SeoFilters filterBtns={
              [
                { id: "seo_dashboard_btn", name: "SEO Dashboard", navigateTo: "/seo_dashboard" },
                { id: "geo_reporting_btn", name: "Geo Reporting", navigateTo: "/seo_dashboard/geo_reporting" },

              ]} hideFilters hasIgniteSetup />}
            iframeUrl={"https://lookerstudio.google.com:/embed/reporting/0e958530-f412-480e-8933-916479cdb685/page/egRXB"}
          />
        </ErrorBoundary>
      </IframeLayout>
    </>
  )
}

export default SearchInterestReport
